import React from 'react';
import { IList } from '../interfaces/IList';
import { Box, BoxProps, List, ListItem, styled } from '@mui/material';
import { Link } from 'react-router-dom';
import CmsImage from './CmsImage';
import CmsMaterialPredefinedIcon from './CmsMaterialPredefinedIcon';

const StyledBox = styled(Box)<BoxProps>(({theme}) => ({
    display: 'flex',
    justifyContent: 'left',
    alignItems: 'center'
}));

const CmsList : React.FC<IList> = ({listitems}) => {
    return <List>
        {listitems?.map(listItem => <>
            <ListItem>
                    {(!!listItem?.pageRef || !!listItem?.href) && <Link to={(listItem?.pageRef?.relativeUrl??(listItem?.href)??'#')} target={listItem?.href ? "_blank" : "_self"}>
                        <StyledBox>
                            {listItem?.muiicon && <Box sx={{marginRight: '0.5em'}}><CmsMaterialPredefinedIcon icon={listItem?.muiicon}  /></Box>}
                            {listItem?.image && <Box sx={{marginRight: '0.5em'}}><CmsImage {...listItem?.image} /></Box>}
                            <Box>{listItem?.text}</Box>
                        </StyledBox>
                    </Link>}
                    {!listItem?.pageRef && !listItem.href && <StyledBox>
                            {listItem?.text}
                        </StyledBox>}
            </ListItem>
        </>)}
    </List>
}

export default CmsList;